"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Facebook = void 0;
var _react = _interopRequireDefault(require("react"));
var Facebook = exports.Facebook = function Facebook() {
  return _react["default"].createElement("svg", {
    width: "36",
    height: "37",
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("rect", {
    width: "36",
    height: "36",
    rx: "2",
    fill: "#1877F2"
  }), _react["default"].createElement("path", {
    d: "M24.9516 22.8038L25.7808 17.3974H20.5936V13.889C20.5936 12.4099 21.3182 10.9682 23.6416 10.9682H26V6.36542C26 6.36542 23.8596 6.00012 21.8133 6.00012C17.5411 6.00012 14.7489 8.58934 14.7489 13.2768V17.3974H10V22.8038H14.7489V35.8734C15.7011 36.0228 16.677 36.1006 17.6712 36.1006C18.6654 36.1006 19.6414 36.0228 20.5936 35.8734V22.8038H24.9516Z",
    fill: "white"
  }));
};